<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7101_7131)">
      <circle cx="10" cy="10" r="9.5" stroke="white" />
      <path
        d="M8.7087 11.5909L8.5102 14.3829C8.7942 14.3829 8.91721 14.2609 9.06471 14.1144L10.3962 12.8419L13.1553 14.8624C13.6613 15.1444 14.0178 14.9959 14.1543 14.3969L15.9654 5.91072L15.9659 5.91022C16.1264 5.16221 15.6954 4.8697 15.2024 5.0532L4.5571 9.1288C3.83058 9.41081 3.84159 9.81582 4.4336 9.99932L7.15516 10.8458L13.4768 6.89025C13.7743 6.69324 14.0448 6.80225 13.8223 6.99925L8.7087 11.5909Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_7101_7131">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
